import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TaxService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public list() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/taxes')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

}
